import t from"styled-components";import{ColorTokens as e}from"@vds-tokens/color";const i=t.span.withConfig({displayName:"RedText",componentId:"VDS__sc-10f6tk5-0"})`
  font-size: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  color: ${e.palette.red.value};
`;export{i as default};
